import { Reveal } from '@/components/generals/reveal'
import { SectionHeading } from '@/components/generals/section-heading'
import { DashboardMock } from '@/components/landing/home/dashboard-mock'

export const DashboardShowcase = () => {
    return (
        <section id='dashboard' aria-label='Dashboard' className='relative overflow-hidden py-24 sm:py-32'>
            <div className='shell'>
                <SectionHeading
                    eyebrow='Your dashboard'
                    size='lg'
                    title={'The whole picture,\n*laid out simply*'}
                    subtitle='Balances, goals, upcoming bills and timely suggestions, set out in the order a trusted advisor would walk you through them.'
                />

                <div className='relative mt-16'>
                    <div
                        aria-hidden='true'
                        className='motion-glow pointer-events-none absolute -inset-x-10 -top-24 bottom-10 rounded-[80px] bg-[radial-gradient(50%_55%_at_50%_30%,rgba(226,243,122,0.2),rgba(143,174,98,0.07)_45%,rgba(0,0,0,0)_72%)] blur-2xl'
                    />

                    <Reveal y={70} blur={10} className='relative'>
                        <DashboardMock />
                    </Reveal>
                </div>
            </div>
        </section>
    )
}
